module.exports = __webpack_public_path__ + "static/media/logo_juego_letra_M.f525ca3c.bin";